import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";

import { IRegistryInstitution } from "../model/RegistryInstitution";
import RegistryInstitutionMapper from "../service/RegistryInstitutionMapper";
import Constants from "../common/Constants";
import RegistryInstitutionParamMapper from "../service/RegistryInstitutionParamMapper";

export default class GetAllRegistryInstitutionsInteractor {
  private resource: GetAllResourceEntriesInteractor<IRegistryInstitution>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute() {
    return this.resource.execute(
      Constants.registryInstitutionPath,
      RegistryInstitutionMapper,
      RegistryInstitutionParamMapper
    );
  }
}
